import React, { useEffect, useState } from "react";
import { Search, Filter } from "lucide-react";
import AdminAppBody from "../../../../components/admin/AdminAppBody";
import useApiCallHooks from "../../../../hooks/useApiCallHooks";
import { toast } from "react-toastify";

const StudentDailyTask = () => {
    const [searchTerm, setSearchTerm] = useState("");
    const [statusFilter, setStatusFilter] = useState("Select Status");
    const [showModal, setShowModal] = useState(false);
    const [selectedTask, setSelectedTask] = useState(null);
    const [isCall, setIsCall] = useState(false);

    const [formData, setFormData] = useState({
        student_task_id: "",
        status: "",
        completed_date: "",
        student_remark: "",
        attachment: null,
    });

    const [responce, loading, error, callAPI, statusCode] = useApiCallHooks();
    const [tasks, setTasks] = useState([]);

    useEffect(() => {
        callAPI("get", "student/get-student-assign-task");
    }, []);

    useEffect(() => {
        if (responce && responce.data && statusCode === 200) {
            const formattedTasks = responce.data.map((item) => ({
                id: item.id,
                taskName: item.task?.task || "N/A",
                moduleName: `Module ${item.task?.module_id || ""}`,
                topicName: `Topic ${item.task?.topic_id || ""}`,
                mentor: item.mentor
                    ? `${item.mentor.first_name} ${item.mentor.last_name}`
                    : "N/A",
                dueDate: item.due_date || "-",
                completedDate: item.completed_date || "-",
                status: item.status === 1 ? "Complete" : "Not Complete",
            }));
            setTasks(formattedTasks);
        }
    }, [responce]);

    const filteredTasks = tasks.filter(
        (task) =>
            (task.taskName + task.moduleName + task.topicName + task.mentor)
                .toLowerCase()
                .includes(searchTerm.toLowerCase()) &&
            (statusFilter === "Select Status" || task.status === statusFilter)
    );

    const handleOpenModal = (task) => {
        setSelectedTask(task);
        setIsCall(false);
        setFormData({
            student_task_id: task.id,
            status: "",
            completed_date: "",
            student_remark: "",
            attachment: null,
        });
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedTask(null);
        setFormData({
            student_task_id: "",
            status: "",
            completed_date: "",
            student_remark: "",
            attachment: null,
        });
    };

    const handleUpdateTask = (e) => {
        e.preventDefault();
        const data = new FormData();
        data.append("student_task_id", formData.student_task_id);
        data.append("status", formData.status);
        data.append("completed_date", formData.completed_date);
        data.append("student_remark", formData.student_remark);
        if (formData.attachment) {
            data.append("attachment", formData.attachment);
        }
        console.log("Sending to API:", Object.fromEntries(data.entries()));
        callAPI("post", "student/update-student-assign-task", data);
        handleCloseModal();
    };

  if (statusCode === 202 && !isCall) {
  setIsCall(true);
  toast.success("Tasks fetched successfully!"); // ✅ Show success toast

  callAPI("get", "student/get-student-assign-task");
  // setTasks([]);
}


    return (
        <AdminAppBody
            loading={loading}
            content={
                <div className="min-vh-100 bg-light">
                    <style>{`
            .update-btn:hover {
              background-color: #0047ab !important;
              color: white !important;
              border-color: transparent !important;
              transform: translateY(-1px);
            }
            .modal-overlay {
              position: fixed;
              top: 0; left: 0;
              width: 100%; height: 100%;
              background-color: rgba(0, 0, 0, 0.5);
              display: flex; justify-content: center; align-items: center;
              z-index: 1050;
            }
            .modal-content-custom {
              background: white;
              padding: 25px;
              width: 90%; max-width: 500px;
              border-radius: 10px;
              box-shadow: 0 0 20px rgba(0,0,0,0.2);
            }
          `}</style>

                    <div className="container-fluid p-3 p-md-4">
                        {/* Search & Filter */}
                        <div className="card border-0 shadow-sm mb-4">
                            <div className="card-body py-3">
                                <div className="row align-items-center">
                                    <div className="col-md-6 mb-2 mb-md-0">
                                        <div className="position-relative">
                                            <Search
                                                className="position-absolute text-muted"
                                                style={{
                                                    left: 15,
                                                    top: "50%",
                                                    transform:
                                                        "translateY(-50%)",
                                                    width: 18,
                                                    height: 18,
                                                }}
                                            />
                                            <input
                                                type="text"
                                                className="form-control ps-5 border-secondary"
                                                placeholder="Search"
                                                value={searchTerm}
                                                onChange={(e) =>
                                                    setSearchTerm(
                                                        e.target.value
                                                    )
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6 d-flex justify-content-md-end align-items-center gap-3">
                                        <div className="d-flex align-items-center">
                                            <Filter
                                                className="me-2 text-muted"
                                                style={{
                                                    width: 18,
                                                    height: 18,
                                                }}
                                            />
                                            <span className="text-muted fw-medium">
                                                Filter:
                                            </span>
                                        </div>
                                        <select
                                            className="form-select border-secondary"
                                            value={statusFilter}
                                            onChange={(e) =>
                                                setStatusFilter(e.target.value)
                                            }
                                            style={{ minWidth: 150 }}
                                        >
                                            <option>Select Status</option>
                                            <option>Complete</option>
                                            <option>Not Complete</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Task Table */}
                        <h2
                            className="fw-bold text-dark mb-3"
                            style={{ fontSize: 28 }}
                        >
                            All Tasks
                        </h2>
                        <div className="card border-0 shadow-sm">
                            <div className="table-responsive table-bordered">
                                <table className="table table-bordered mb-0">
                                    <thead>
                                        <tr
                                            className="bg-info"
                                            style={{
                                                backgroundColor: "#e3f2fd",
                                            }}
                                        >
                                            <th className="text-dark fw-semibold py-3 px-4">
                                                Sr No
                                            </th>
                                            <th className="text-dark fw-semibold py-3 px-4">
                                                Task Name
                                            </th>
                                            <th className="text-dark fw-semibold py-3 px-4">
                                                Module Name
                                            </th>
                                            <th className="text-dark fw-semibold py-3 px-4">
                                                Topic Name
                                            </th>
                                            <th className="text-dark fw-semibold py-3 px-4">
                                                Mentor
                                            </th>
                                            <th className="text-dark fw-semibold py-3 px-4">
                                                Due Date
                                            </th>
                                            <th className="text-dark fw-semibold py-3 px-4">
                                                Completed Date
                                            </th>
                                            <th className="text-dark fw-semibold py-3 px-4">
                                                Status
                                            </th>
                                            <th className="text-dark fw-semibold py-3 px-4">
                                                Action
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredTasks.map((task, i) => (
                                            <tr key={task.id}>
                                                <td className="py-3 px-4">
                                                    {i + 1}
                                                </td>
                                                <td className="py-3 px-4 text-primary">
                                                    {task.taskName}
                                                </td>
                                                <td className="py-3 px-4">
                                                    {task.moduleName}
                                                </td>
                                                <td className="py-3 px-4">
                                                    {task.topicName}
                                                </td>
                                                <td className="py-3 px-4">
                                                    {task.mentor}
                                                </td>
                                                <td className="py-3 px-4">
                                                    {task.dueDate}
                                                </td>
                                                <td className="py-3 px-4">
                                                    {task.completedDate}
                                                </td>
                                                <td className="py-3 px-4">
                                                    <span
                                                        className={`fw-medium ${
                                                            task.status ===
                                                            "Complete"
                                                                ? "text-success"
                                                                : "text-danger"
                                                        }`}
                                                    >
                                                        {task.status}
                                                    </span>
                                                </td>
                                                <td className="py-3 px-4">
                                                    <button
                                                        className="bg-white px-4 py-2 fw-medium update-btn"
                                                        style={{
                                                            border: "2px solid #0047ab",
                                                            borderRadius: 4,
                                                            fontSize: 14,
                                                        }}
                                                        onClick={() =>
                                                            handleOpenModal(
                                                                task
                                                            )
                                                        }
                                                    >
                                                        Update
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                        {filteredTasks.length === 0 && (
                                            <tr>
                                                <td
                                                    className="text-center py-3 px-4"
                                                    colSpan="9"
                                                >
                                                    No tasks found.
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    {/* Modal */}
                    {showModal && (
                        <div className="modal-overlay">
                            <div className="modal-content-custom">
                                <h5>Update Task</h5>
                                <form onSubmit={handleUpdateTask}>
                                    {/* Status */}
                                    <div className="mb-3">
                                        <label className="form-label">
                                            Status
                                        </label>
                                        <select
                                            className="form-control"
                                            value={formData.status}
                                            onChange={(e) =>
                                                setFormData({
                                                    ...formData,
                                                    status: e.target.value,
                                                })
                                            }
                                        >
                                            <option value="">
                                                Select Status
                                            </option>
                                            <option value="1">Complete</option>
                                            <option value="0">
                                                Not Complete
                                            </option>
                                        </select>
                                         <span className="val-message text-danger">
                  {error?.message === "ValidationError" && error?.data?.status}
                </span>
                                    </div>

                                    {/* Completed Date */}
                                    <div className="mb-3">
                                        <label className="form-label">
                                            Completed Date
                                        </label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            value={formData.completed_date}
                                            onChange={(e) =>
                                                setFormData({
                                                    ...formData,
                                                    completed_date:
                                                        e.target.value,
                                                })
                                            }
                                        />
                                    </div>

                                    {/* Comment */}
                                    <div className="mb-3">
                                        <label className="form-label">
                                            Comment
                                        </label>
                                        <textarea
                                            rows="3"
                                            className="form-control"
                                            value={formData.student_remark}
                                            onChange={(e) =>
                                                setFormData({
                                                    ...formData,
                                                    student_remark:
                                                        e.target.value,
                                                })
                                            }
                                            placeholder="Write a comment..."
                                        />
                                         <span className="val-message text-danger">
                  {error?.message === "ValidationError" && error?.data?.student_remark}
                </span>
                                    </div>

                                    {/* Attachment */}
                                    <div className="mb-3">
                                        <label className="form-label">
                                            Upload Attachment
                                        </label>
                                        <input
                                            type="file"
                                            className="form-control"
                                            accept=".txt,image/jpeg,image/png,image/gif,image/webp"
                                            onChange={(e) =>
                                                setFormData({
                                                    ...formData,
                                                    attachment:
                                                        e.target.files[0],
                                                })
                                            }
                                        />
                                        <small className="text-muted">
                                            Select <strong>either</strong> a
                                            text file (.txt) or image (JPEG,
                                            PNG, GIF, WEBP) under 50KB.
                                        </small>
                                    </div>

                                    <div className="d-flex justify-content-end gap-3">
                                        <button
                                            type="button"
                                            className="btn btn-light border border-primary"
                                            onClick={handleCloseModal}
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            type="submit"
                                            className="btn btn-primary"
                                        >
                                            Update
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    )}
                </div>
            }
        />
    );
};

export default StudentDailyTask;
